import { Component, Input, OnInit } from '@angular/core';
import { User } from '../../types/user.model';

@Component({
  selector: 'mmb-web-app-profile-details-section',
  templateUrl: './profile-details-section.component.html',
  styleUrls: ['./profile-details-section.component.scss']
})
export class ProfileDetailsSectionComponent implements OnInit {
  @Input() user: User;
  
  constructor() { }

  ngOnInit() {
  }

}
